import queryString from "query-string";
import { removeClass } from "../utilities";

/**
 * Fetch ad
 * Viewloader compatible function
 * @param  {Node} el DOM node the function is bound to
 * @return {Void}
 */

export default function fetchAd(el, props) {
  const advertisementWrapper = el.querySelector(".advertisement");
  const advertisementBox = el.querySelector(".advertisement__box");
  const contentType = props.contentType;
  const pagePath = props.pagePath;
  const label = props.label;
  const size = props.size;

  const adOptions = {
    content_type: contentType,
    page_path: pagePath,
    size: size
  };

  fetch(`/ads.json?${queryString.stringify(adOptions)}`, {
    method: "GET",
    credentials: "same-origin",
    headers: {
      accept: "application/json"
    }
  })
    .then(response => {
      // A 204 status code is returned if no ad is found
      if (response.status !== 200) {
        advertisementWrapper.parentNode.removeChild(advertisementWrapper);
        // We don't have an ad to serve, so abort the request
        throw Error;
      }
      return response.json();
    })
    .then(ad => {
      advertisementBox.innerHTML = `
        <a href="${ad.target_url}" target="_blank" rel="noopener" ga-on="click,auxclick,contextmenu" ga-event-category="ad" ga-event-action="click" ga-event-label="${label} - ${ad.campaign_name}">
          <img src="${ad.image_url}"/>
        </a>
      `;

      // Remove the hidden class from advertisementWrapper to expose the ad
      removeClass(advertisementWrapper, "advertisement--hidden");
    })
    .catch(function() {
      return;
    });
}
